/* eslint-disable react/no-deprecated */
/* eslint-disable react/display-name */
import React ,  { Fragment }  from "react";
import UsageEvent from "./usageEvent/UsageEventsContainer";
import LoginAuthToken from "./form/LoginAuthToken";
import { Switch, Route, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { getAuthorizationKeyWithExpiry } from "../utils/api";

class Application extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const userLoggedIn = getAuthorizationKeyWithExpiry("token");
    return (
      <Fragment>
        <Switch>
          <Route
            exact
            path="/login"
            render={() => {
              if ( userLoggedIn == null) {
                return <LoginAuthToken />;
              }
              return <Redirect to="/usageevent" />;
            }}
          />
          <Route
            exact
            path="/usageevent"
            render={() => {
              if ( userLoggedIn == null) {
                return <Redirect to="/login" />;
              }
              return <UsageEvent />;
            }}
          />
          <Route
            path="*"
            render={() => {
              if (userLoggedIn == null) {
                return <Redirect to="/login" />;
              }
              return <Redirect to="/usageevent" />;
            }}
          />
        </Switch>
      </Fragment>
    );
  }
}

export default withRouter(Application);
